import React, { JSX } from 'react';
import { ListRowItem, SimpleListProps, Sorting } from './types';

const smallGroup = 'Kleingruppenreise';
const miniGroup = 'Minigruppenreise';

const TableHead = <L extends ListRowItem>({
  headItems,
  currentSorting,
  onSortClick,
  enableTabRole = false
}: {
  headItems: SimpleListProps<L>['headItems'];
  currentSorting: Sorting;
  onSortClick: (sortProp: string, isAscDirection?: boolean) => void;
  enableTabRole?: boolean;
}): JSX.Element => {
  return (
    <thead className="simple-list__head">
      <tr>
        {headItems.map(item => {
          const classSortable = item.sortProp ? ' simple-list__head-item--sortable' : '';
          const classSortableActive =
            !!item.sortProp && item.sortProp === currentSorting.sortProp
              ? ' simple-list__head-item--sorting-active'
              : '';
          const classGroupSize =
            item.value === smallGroup || item.value === miniGroup ? '--groupSize' : '';

          let onClick: React.MouseEventHandler = () => {};
          let onKeyDown: React.KeyboardEventHandler = () => {};
          let tabIndex: number = -1;
          let role = '';

          if (item.value !== smallGroup && !!item.sortProp) {
            onClick = (): void => onSortClick(item.sortProp ?? '');
            onKeyDown = (event): void => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                onSortClick(item.sortProp ?? '');
              }
            };

            if (enableTabRole) {
              tabIndex = 0;
              role = 'tab';
            }
          }

          return (
            <th
              key={item.value}
              className={`simple-list__head-item${classSortable}${classSortableActive}${classGroupSize}`}
              onClick={onClick}
              onKeyDown={onKeyDown}
              tabIndex={tabIndex}
              role={role}
            >
              <span>{item.value === smallGroup || item.value === miniGroup ? '' : item.value}</span>
              {!!item.sortProp && item.sortProp === currentSorting.sortProp && (
                <span
                  className={`simple-list__sort-icon${
                    !currentSorting.isAscDirection ? ' simple-list__sort-icon--flipped' : ''
                  }`}
                />
              )}
            </th>
          );
        })}
      </tr>
    </thead>
  );
};

export default TableHead;
